export default "__VITE_ASSET__BNNqjOsU__"